import {
  SYSTEM_GET_ALL_EXPERIENCE_BEGIN,
  SYSTEM_GET_ALL_EXPERIENCE_SUCCESS,
  SYSTEM_GET_ALL_EXPERIENCE_FAILURE,
  SYSTEM_GET_ALL_EXPERIENCE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllExperience(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEM_GET_ALL_EXPERIENCE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/workExperience/list',
        }).then( data => {
            dispatch({
                type: SYSTEM_GET_ALL_EXPERIENCE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_GET_ALL_EXPERIENCE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllExperienceError() {
  return {
    type: SYSTEM_GET_ALL_EXPERIENCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_GET_ALL_EXPERIENCE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllExperiencePending: true,
        getAllExperienceError: null,
      };

    case SYSTEM_GET_ALL_EXPERIENCE_SUCCESS:
      // The request is success
      const byId = {};
      const items = [];
      action.data.list.forEach(item => {
        items.push(item.id);
        byId[item.id] = item;
      });
      return {
        ...state,
        allWorkExperienceById:byId,
        allWorkExperienceList:items,
        getAllExperiencePending: false,
        getAllExperienceError: null,
      };

    case SYSTEM_GET_ALL_EXPERIENCE_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllExperiencePending: false,
        getAllExperienceError: action.data.error,
      };

    case SYSTEM_GET_ALL_EXPERIENCE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllExperienceError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/getAllExperience.js